import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bold',
  standalone: false,
})
export class BoldPipe implements PipeTransform {
  constructor() {}
  transform(value: string) {
    if (!value) return '';
    return '<strong>' + value + '</strong>';
  }
}
